import {ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {Favorite} from '@models/favorite';
import {UserSearch, UserSearchCity} from '@models/search';
import {PARTNER_MAX_SEARCH} from '@models/user';
import {City} from '@models/city';
import {CityService} from '@services/city.service';
import {ImageService} from '@services/image.service';
import {MatMenuTrigger} from '@angular/material/menu';
import {Observable, of, Subject} from 'rxjs';
import {AdService} from '@services/ad.service';
import {UserService} from '@services/user.service';
import {AlertService} from '@services/alert.service';
import {DialogPosition, MatDialog} from '@angular/material/dialog';
import {Location} from '@angular/common';
import {HttpClient} from '@angular/common/http';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthenticationService} from '@services/authentification.service';
import {TrackingService} from '@services/tracking.service';
import {CommonService} from '@services/common.service';
import {ConfirmComponent} from '@components/popup/confirm/confirm.component';
import {SaveComponent} from '@module/search/popup/save/save.component';
import {AlertComponent} from '@module/search/popup/alert/alert.component';
import {OnboardingService} from '@services/onboarding.service';
import {PubSaveComponent} from '@module/search/popup/pub-save/pub-save.component';
import {PubOpenComponent} from '@module/search/popup/pub-open/pub-open.component';
import {environment} from '~/environments/environment';
import {LoginFormComponent} from '@components/popup/login-form/login-form.component';
import {EMPTY_FAVORITE_LIST, EVOL_DEMO_LAST_YEAR, SEARCH_PARAMS} from '@models/empty';
import * as _ from 'underscore';
import {Title} from '@angular/platform-browser';
import {PreviewPopupComponent} from '@module/search/results/preview-popup/preview-popup.component';
import {EditComponent} from '@module/search/popup/edit/edit.component';
import {DuplicateComponent} from '@module/search/popup/duplicate/duplicate.component';
import {AlertConfirmComponent} from '@module/search/popup/alert-confirm/alert-confirm.component';
import {UpgradePlanV2Component} from '@components/popup/upgrade-plan-v2/upgrade-plan-v2.component';
import {DemoAccountComponent} from '@components/popup/demo-account/demo-account.component';
import {AlertHsComponent} from '@module/search/popup/alert-hs/alert-hs.component';
import {ToomanyFavComponent} from '@components/popup/toomany-fav/toomany-fav.component';
import {AddComponent} from '@module/favorites/popup/add/add.component';
import {BugComponent} from '@module/annonces/popup/bug/bug.component';
import {NotesComponent} from '@module/favorites/popup/notes/notes.component';
import {TutoComponent} from '@components/popup/tuto/tuto.component';
import {DeviceDetectorService} from 'ngx-device-detector';
import {Options} from '@angular-slider/ngx-slider';
import {ResultsFloatingBase} from '../results-floating-base';
import {TOO_MANY_REQUESTS} from '~/app/shared/helpers/error.interceptor';

@Component({
    selector: 'app-results',
    templateUrl: './results.component.html',
    styleUrls: ['./results.component.scss'],
})
export class ResultsComponent extends ResultsFloatingBase implements OnInit {
    favorites: Favorite[] = [];
    cacheFavorites: Favorite[] = [];
    loading = true;
    skeletons: number[] = new Array(10).fill(0);
    nb_result = -1;

    params;
    sort = 'first_publication-desc';
    sortOptions = [
        {value: 'first_publication-desc', label: 'Date (Décroissant)'},
        {value: 'first_publication-asc', label: 'Date (Croissant)'},
        {value: 'price-desc', label: 'Prix (Décroissant)'},
        {value: 'price-asc', label: 'Prix (Croissant)'},
        {value: 'square_price-desc', label: 'Prix au m² (Décroissant)'},
        {value: 'square_price-asc', label: 'Prix au m² (Croissant)'},
        {value: 'square_price_diff-desc', label: 'Diff de prix au m² (Décroissant)'},
        {value: 'square_price_diff-asc', label: 'Diff de prix au m² (Croissant)'},
    ];
    // Recherche dans le sélecteur de recherches (mobile)
    searchListText = '';
    idSearch = '';
    onboarding = false;
    url = '';

    currentSearch: UserSearch;
    userSearchs: UserSearch[] = [];
    // Secteurs enregistrés proposés dans la popup « Zone de recherche »
    userSearchsCity: UserSearchCity[] = [];

    // Barre de filtres (chips desktop, même design que les favoris)
    @ViewChild('adsTop') adsTop: ElementRef;
    @ViewChild('villeTrigger') villeTrigger: MatMenuTrigger;
    @ViewChild('priceTrigger') priceTrigger: MatMenuTrigger;
    @ViewChild('surfaceTrigger') surfaceTrigger: MatMenuTrigger;
    @ViewChild('rendementTrigger') rendementTrigger: MatMenuTrigger;
    @ViewChild('typeTrigger') typeTrigger: MatMenuTrigger;
    @ViewChild('cashflowTrigger') cashflowTrigger: MatMenuTrigger;
    @ViewChild('dpeTrigger') dpeTrigger: MatMenuTrigger;
    filterChanged$ = new Subject<void>();
    villeSearchText = '';
    villeResults$: Observable<City[]> = of([]);
    // Types de bien de premier niveau (mêmes valeurs/libellés que la page filtres)
    estateTypeOptions = [
        {value: 'maison', label: 'Maison'},
        {value: 'appartement', label: 'Appartement'},
        {value: 'parking', label: 'Garage'},
        {value: 'immeuble', label: 'Immeuble'},
        {value: 'terrain', label: 'Terrain'},
        {value: 'commerce-fonddecommerce', label: 'Commerce'},
        {value: 'autre', label: 'Autre'},
    ];

    stripe = Stripe(environment.stripeKey);
    columsSelection = false;
    displayedColumns: string[] = [];
    max_display = 20;

    loginForm = null;

    page = 1;
    pages = [];
    // L'API ne pagine pas au-delà des 250 premiers résultats (25 pages de 10)
    maxResults = 250;

    get maxPage(): number {
        return this.maxResults / 10;
    }

    sub_search = null;

    constructor(
        cdr: ChangeDetectorRef,
        public adService: AdService,
        private userService: UserService,
        private alertService: AlertService,
        public onboardingService: OnboardingService,
        private dialog: MatDialog,
        private location: Location,
        private http: HttpClient,
        private route: ActivatedRoute,
        public router: Router,
        private deviceService: DeviceDetectorService,
        private titleService: Title,
        public authenticationService: AuthenticationService,
        public trackingService: TrackingService,
        private commonService: CommonService,
        public cityService: CityService,
        public imageService: ImageService) {
        super(cdr);
    }

    ngOnInit(): void {
        // Filtres rapides (chips) : la saisie ne lance aucune requête, l'application se
        // fait au clic sur « Appliquer » dans la popup. Les libellés/compteurs des chips
        // suivent en direct le brouillon en cours d'édition.
        this.filterChanged$.subscribe(() => this.refreshFilterStats());
        this.villeResults$ = this.cityService.autocomplete(this.villeSearch$);

        this.router.events.subscribe((val) => {
            if (this.loginForm !== null) {
                clearTimeout(this.loginForm);
                this.loginForm = null;
            }
        });

        this.params = {'id': ''};
        if (this.authenticationService.isLogin) {
            this.adService.getUserSearch().subscribe(r => {
                if (this.authenticationService.isAllowed('essentiel')) {
                    this.userSearchs = r;
                }
                this.setParams();
            });
            if (this.authenticationService.isAllowed('essentiel')) {
                this.adService.getUserSearchCity().subscribe(r => this.userSearchsCity = r);
            }
            if (this.authenticationService.currentUser.user_dashboard.search_kpi === undefined || this.authenticationService.currentUser.user_dashboard.search_kpi === null || this.authenticationService.currentUser.user_dashboard.search_kpi.length == 0 || !this.authenticationService.isAllowed('expert')) {
                this.displayedColumns = ['ad_city.price_diff', 'ad_city.demographie_annuelle', 'ad_city.carac_commune.mv', 'favorite.ad_city.renta', 'ad_city.carac_commune.te', 'ad_city.advice_price', 'amount_rent', 'ad_city.carac_commune.tc'];
            } else {
                this.displayedColumns = this.authenticationService.currentUser.user_dashboard.search_kpi;
            }
        } else {
            this.trackingService.click('search_result_open_login', '');
            this.displayedColumns = ['ad_city.price_diff', 'ad_city.demographie_annuelle', 'ad_city.carac_commune.mv', 'favorite.ad_city.renta', 'ad_city.carac_commune.te', 'ad_city.advice_price', 'amount_rent', 'ad_city.carac_commune.tc'];
            this.loginForm = setTimeout(() => {
                const dialogRef = this.dialog.open(LoginFormComponent, {
                    width: '550px',
                    disableClose: true,
                    data: {
                        disableClose: true
                    },
                });
            }, 10000);
            this.setParams();
        }

        this.onboardingService.listen().subscribe(elem => {
            if (elem == 'search_start') {
                this.onboarding = true;
                if (this.favorites.length > 3) {
                    this.cacheFavorites = this.favorites;
                    this.favorites = [this.favorites[0], this.favorites[1]];
                }
            }
            if (elem == 'search_end') {
                // endSearch() est aussi émis HORS onboarding (clic « Rechercher » des filtres) :
                // ne restaurer le cache que si un tour a réellement tronqué la liste,
                // sinon on écrase les résultats avec un cache vide -> liste vide
                if (this.onboarding === true) {
                    this.favorites = this.cacheFavorites;
                }
                this.onboarding = false;
            }
        });
        if (this.authenticationService.currentUser.user_onboarding.auto && this.authenticationService.currentUser.user_onboarding.search.status == 'done' && this.authenticationService.currentUser.user_onboarding.search_save.status == 'not_started') {
            this.onboardingService.startSearchSave().subscribe();
        }

        if (this.deviceService.isMobile()) {
            this.max_display = 6
        }
    }

    setParams() {
        this.route.queryParams.subscribe(params => {
            const previousPage = this.page;
            if (params.page) {
                this.page = parseInt(params.page);
            } else {
                this.page = 1;
            }
            if (this.page !== previousPage && !this.route.snapshot.fragment) {
                this.scrollToAdsTop();
            }
            // Sans l'ancre #ad_... ni le ?page d'un éventuel retour (le returnUrl est
            // reconstruit avec la page courante par adReturnUrl)
            this.url = this.router.url.split('#')[0].split('?')[0];

            this.route.params.subscribe(params => {
                this.params = params;
                if (params.id !== undefined) {
                    this.idSearch = params.id;
                    if (this.idSearch == 'result') {
                        this.userService.getCurrentSearch().subscribe(params => {
                            this.currentSearch = params;
                            this.search(null);
                        });
                    } else {
                        this.setSearch();
                        if (this.authenticationService.currentUser.user_onboarding.auto
                            && this.authenticationService.currentUser.user_onboarding.search.status != 'not_started'
                            && this.authenticationService.currentUser.user_onboarding.search_save.status != 'not_started'
                            && this.authenticationService.currentUser.user_onboarding.alert.status == 'not_started'
                        ) {
                            this.onboardingService.startAlert(this.idSearch).subscribe();
                        }
                    }
                }
            });
        });

        // Retour depuis une annonce (returnUrl avec ancre #ad_...) : re-scrolle jusqu'à la carte.
        // Abonné au fragment (et pas un appel unique) : couvre aussi une navigation où seule
        // l'ancre change (le composant n'est alors pas recréé).
        this.route.fragment.subscribe(() => this.commonService.scrollToHashCard());
    }

    // Changement de page : remonte en haut de la liste (sous le header fixe), seulement si on est plus bas
    scrollToAdsTop() {
        if (!this.adsTop) {
            return;
        }
        const header = document.querySelector('app-header');
        const offset = header ? header.getBoundingClientRect().bottom : 0;
        const top = this.adsTop.nativeElement.getBoundingClientRect().top + window.scrollY - offset;
        if (window.scrollY > top) {
            window.scrollTo({top, behavior: 'instant'} as any);
        }
    }

    setSearch() {
        if (this.idSearch !== undefined) {
            if (this.authenticationService.isAllowed('essentiel')) {
                this.userSearchs.forEach(f => {
                    if (f.id === parseInt(this.idSearch, 10)) {
                        this.currentSearch = f;
                        this.search(null);
                    }
                });
                if (this.currentSearch == null) {
                    this.router.navigate(['/app/search/result']);
                    this.userService.getCurrentSearch().subscribe(params => {
                        this.currentSearch = params;
                        this.search(null);
                    });
                } else {
                    this.verifyAlert();
                }
            } else {
                this.alertService.error('Cette fonctionnalité nécessite un plan supérieur, consultez nos forfaits dans Mon compte > Nos forfaits');
                this.router.navigate(['/app/search/result']);
            }
        }
    }

    // Pages suivantes réservées aux plans complets (l'API refuse aussi en 403).
    canPaginate(): boolean {
        return this.authenticationService.isAllowed('essentiel') && !this.authenticationService.isPartner;
    }

    // Clic sur une page verrouillée : rappel des limites pour un compte démo, upsell sinon.
    pageLocked() {
        if (this.authenticationService.isPartner) {
            this.showDemoAccount();
        } else {
            this.upgradePlan('assets/upgrade/search.png', 'Moteur de recherche', 'Essentiel');
        }
    }

    showDemoAccount() {
        if (this.dialog.openDialogs.length === 0) {
            this.dialog.open(DemoAccountComponent, {width: '420px'});
        }
    }

    upgradePlan(visuel = '', feature, plan) {
        this.trackingService.click('search_result_upgrade_plan', feature);
        if (!this.authenticationService.isLogin) {
            const dialogRef = this.dialog.open(LoginFormComponent, {
                width: '550px',
                data: {
                    disableClose: false
                },
            });
        } else {
            const dialogRef = this.dialog.open(UpgradePlanV2Component, {
                width: '520px',
                data: {visuel, plan, feature}
            });
        }
    }

    verifyAlert() {
        if (this.currentSearch.frequency_alert != '0' && !this.authenticationService.isAllowed('essentiel')) {
            this.trackingService.click('search_result_search_alert_hs_open', this.currentSearch.id);
            const dialogRef = this.dialog.open(AlertHsComponent, {
                width: '480px',
                data: {userSearch: this.currentSearch},
            });

            dialogRef.afterClosed().subscribe(result => {
                if (result !== false && result !== undefined) {
                    this.trackingService.click('search_result_search_alert_hs_confirm', this.currentSearch.id);
                    this.saveAlerte();
                } else {
                    this.trackingService.click('search_result_search_alert_hs_cancel', this.currentSearch.id);
                }
            });
        }
    }

    setSort() {
        this.currentSearch.search_ad_params.sort = this.sort.split('-')[0];
        this.currentSearch.search_ad_params.sort_order = this.sort.split('-')[1];
        if (this.idSearch != 'result') {
            this.adService.editUserSearch(this.currentSearch).subscribe((us) => {
                this.router.navigate(['/app/search', this.params.id]);
            });
        } else {
            this.userService.setCurrentSearch(this.currentSearch).subscribe((us) => {
                this.router.navigate(['/app/search/result'])
            });
        }

        this.search(1)
    }
    search(page) {
        this.refreshFilterStats();
        if (page !== null) {
            this.page = page;
        }

        if (this.page > 1 && !this.canPaginate()) {
            this.pageLocked();
            if (!this.authenticationService.isPartner) {
                return
            }
            this.page = 1;
        }
        if (this.page > this.maxPage) {
            this.page = this.maxPage;
            this.location.replaceState(this.url, 'page=' + this.page);
        }

        var show = false;
        if (this.userSearchs.length == 0) {
            if (this.authenticationService.currentUser.user_onboarding.popup_search_save == ''
                || this.authenticationService.currentUser.user_onboarding.popup_search_save == undefined) {
                show = true;
            } else {
                var date = new Date();
                var last = new Date(this.authenticationService.currentUser.user_onboarding.popup_search_save);
                if (date.getTime() - last.getTime() > (1000 * 60 * 60) * 6) { // Toute les 6 heures
                    show = true;
                }
            }
        }

        if (this.idSearch == 'result' && this.page > 2 && show == true && this.authenticationService.isLogin) {
            this.authenticationService.currentUser.user_onboarding.popup_search_save = new Date().toString();
            this.userService.updateOnboarding(this.authenticationService.currentUser);
            this.trackingService.click('search_result_search_save_pub_open', this.currentSearch.id);

            const dialogRef = this.dialog.open(PubSaveComponent, {
                width: '420px',
                data: {searchParams: this.currentSearch.search_ad_params, userSearchs: this.userSearchs},
            });

            dialogRef.afterClosed().subscribe(result => {
                if (result !== false && result !== undefined) {
                    this.trackingService.click('search_result_search_save_pub_confirm', this.currentSearch.id);
                    this.userSearchs = result.userSearchs;
                    this.userSearchs.forEach(s => {
                        if (s.id === result.currentSearch.id) {
                            this.currentSearch = s;
                            this.idSearch = '' + this.currentSearch.id;
                            this.location.replaceState('/app/search/' + this.currentSearch.id);
                            this.alertService.success("Enregistrement réussi.");
                        }
                    });
                } else {
                    this.trackingService.click('search_result_search_save_pub_cancel', this.currentSearch.id);
                }
            });
        }

        let page_first = 0;
        let page_last = 0;

        if (this.deviceService.isMobile()) {
            if (this.page > 3) {
                page_first = this.page - 3;
                page_last = this.page + 3;
            } else {
                page_first = 1;
                page_last = 6;
            }
        } else {
            if (this.page > 6) {
                page_first = this.page - 5;
                page_last = this.page + 5;
            } else {
                page_first = 1;
                page_last = 10;
            }
        }


        this.loading = true;
        // Autant de squelettes que d'annonces affichées (10 par page) : la liste garde sa
        // hauteur pendant le rechargement, la scrollbar ne disparaît plus.
        this.skeletons = new Array(this.favorites.length || 10).fill(0);
        this.favorites = [];
        // Pas d'ancien compteur pendant le chargement (-1 = masqué par le template)
        this.nb_result = -1;
        this.trackingService.search({page: this.page});

        if (this.currentSearch.title) {
            this.titleService.setTitle('LyBox - ' + 'Recherche ' + this.currentSearch.title + (this.page > 1 ? ' - Page ' + this.page : ''));
        } else {
            this.titleService.setTitle('LyBox - ' + 'Moteur de recherche' + (this.page > 1 ? ' - Page ' + this.page : ''));
        }
        this.currentSearch.search_ad_params.last = (this.page - 1) * 10;
        this.sort = this.currentSearch.search_ad_params.sort + '-' + this.currentSearch.search_ad_params.sort_order;
        if (this.sort == '-') {
            this.sort = 'first_publication-desc';
        }

        if (this.sub_search) {
            this.sub_search.unsubscribe();
        }

        this.sub_search = this.adService.search(this.currentSearch.search_ad_params).subscribe(res => {

            const favorites = res.favorites;
            this.nb_result = res.result;
            page_last = Math.min(page_last, Math.ceil(this.nb_result / 10), this.maxPage);

            this.pages = [];
            for (let i = page_first; i <= page_last; i++) {
                this.pages.push(i);
            }

            favorites.forEach((favorite, i) => {
                if (favorite.mask) {
                    // Annonce masquée : le back ne renvoie que les champs d'affichage,
                    // on n'effectue aucun recalcul (efficiency, cash-flow, etc.).
                    // Le back ne split pas pictures_string -> on construit le tableau pictures ici.
                    const picturesString = favorite.pictures_string || favorite.ad.pictures_string;
                    favorite.pictures = picturesString
                        ? picturesString.replace(/&amp;/g, '&').replace(/&lt;/g, '<').replace(/&gt;/g, '>').split(';')
                        : ['/assets/no-photo.png'];
                    this.favorites.push(favorite);
                    return;
                }
                favorite.notary_price = null; // To calc them
                favorite = this.adService.fillUSerInfo(favorite);
                this.favorites.push(this.adService.fillDisplayData(favorite, i));
            });

            this.loading = false;
            if (this.onboarding === true) {
                this.cacheFavorites = this.favorites;
                this.favorites = [this.favorites[0], this.favorites[1]];
            }

        }, error => {
            this.loading = false;
            if (error === TOO_MANY_REQUESTS) {
                this.alertService.error(TOO_MANY_REQUESTS);
            } else {
                this.alertService.error('Une erreur est survenue');
            }
            console.log(error);
        });
    }

    deleteFav(favorite) {
        const dialogRef = this.dialog.open(ConfirmComponent, {
            width: '480px',
            data: {message: 'Êtes-vous sûr de vouloir supprimer ce favori et perdre toutes les informations saisies ?'},
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result === true) {
                this.trackingService.deleteFavorite();
                this.adService.deleteFavorite(favorite).subscribe(r => {
                    favorite.id = '';
                    favorite.favorite_list = EMPTY_FAVORITE_LIST;
                });
            }
        });
    }

    saveFav(favorite) {
        if (favorite.id !== '' && favorite.favorite_list.id !== '') {
            setTimeout(() => {
                window.open('/app/favorites/' + favorite.favorite_list.id + '/' + favorite.id, '_blank');
            });
        } else if (favorite.loading === false || favorite.loading === undefined) {
            favorite.loading = true;
            this.trackingService.addFavorite();

            if (this.authenticationService.isLogin) {
                if (!this.authenticationService.isAllowed('basique')) {
                    const dialogRef = this.dialog.open(UpgradePlanV2Component, {
                        width: '520px',
                        data: {visuel: 'assets/upgrade/simulation.png', plan: 'Basique', feature: 'Simulateur d\'investissement', disableClose: true},
                    });
                } else {
                    // authorised so return true
                    const dialogRef = this.dialog.open(AddComponent, {
                        width: '480px',
                        data: {favorite: favorite, mode: 'create'},
                    });

                    dialogRef.afterClosed().subscribe(result => {
                        favorite.loading = false;
                        if (result !== false && result !== undefined) {
                            if (result == 'toomany') {
                                this.trackingService.click('upgrade_plan_favorite_open', this.authenticationService.currentUser.plan);
                                const dialogRef = this.dialog.open(ToomanyFavComponent, {
                                    width: '420px',
                                    data: {
                                        plan: this.authenticationService.currentUser.plan,
                                    },
                                });
                            } else {
                                favorite.id = result[1].id;
                                favorite.favorite_list = result[1].favorite_list;
                            }
                        }
                    });
                }
            } else {
                const dialogRef = this.dialog.open(LoginFormComponent, {
                    width: '550px',
                    disableClose: true,
                    data: {
                        disableClose: true
                    },
                });
            }
        }
    }

    hideFav(favorite) {
        favorite.hide = !favorite.hide;
        this.adService.hideFav(favorite);
    }

    addBug(favorite) {
        const dialogRef = this.dialog.open(BugComponent, {
            width: '480px',
            position: {top: (this.deviceService.isMobile() ? '55px' : '')},
            data: {favorite: favorite},
        });
        dialogRef.afterClosed().subscribe(result => {
            if (result == true) {
                this.trackingService.click('search_result_bug_send', favorite.ad.ai_id);
            } else {
                this.trackingService.click('search_result_bug_close', favorite.ad.ai_id);
            }
        });
    }

    openLybox(favorite, index) {
        if (favorite.loading == true) {
            return;
        }

        if (this.authenticationService.isLogin) {
            this.trackingService.click('search_result_open_ad_plan_open', this.currentSearch.id);
            const dialogRef = this.dialog.open(PubOpenComponent, {
                width: '700px',
                data: {
                    close: true,
                },
            });

            dialogRef.afterClosed().subscribe(result => {
                if (result !== null && result !== undefined && result !== '') {
                    this.trackingService.click('search_result_open_ad_plan_confirm', this.currentSearch.id);
                    this.loading = true;
                    this.http.post<any>(`${environment.apiUrl}app/paiement/create-checkout-session`,
                        {plan: result, duration: 'month'}).subscribe(
                        session => {
                            this.trackingService.checkout({value: result});
                            this.stripe.redirectToCheckout({sessionId: session.id}).then(result => {
                                if (result.error) {
                                    alert(result.error.message);
                                }
                            });
                        },
                        (error) => {
                            console.log(error);
                            this.loading = false;
                            this.alertService.error('Erreur');
                        });
                } else {
                    this.trackingService.click('search_result_open_ad_plan_cancel', this.currentSearch.id);
                }
            });
            return;
        } else {
            this.router.navigate(['/app/login'], {queryParams: {returnUrl: this.router.url}});
        }
    }

    editSearch() {
        const dialogRef = this.dialog.open(EditComponent, {
            width: '420px',
            position: {top: (this.deviceService.isMobile() ? '55px' : '')},
            data: {userSearch: this.currentSearch},
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result !== false && result !== undefined) {
                this.alertService.success('Enregistrement réussi.');
                this.trackingService.click('search_result_search_rename_confirm', this.currentSearch.id);
                this.userSearchs.forEach(s => {
                    if (s.id === result.currentSearch.id) {
                        this.currentSearch = s;
                    }
                });
            } else {
                this.trackingService.click('search_result_search_rename_cancel', this.currentSearch.id);
            }
        });
    }

    duplicateSearch() {
        if (this.authenticationService.isPartner && this.userSearchs.length >= PARTNER_MAX_SEARCH) {
            this.showDemoAccount();
            return;
        }
        const dialogRef = this.dialog.open(DuplicateComponent, {
            width: '420px',
            position: {top: (this.deviceService.isMobile() ? '55px' : '')},
            data: {userSearch: this.currentSearch},
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result !== false && result !== undefined) {
                this.alertService.success('Enregistrement réussi.');
                this.trackingService.click('search_result_search_duplicate_confirm', this.currentSearch.id);
                this.userSearchs.push(result.currentSearch);
                this.userSearchs.forEach(s => {
                    if (s.id === result.currentSearch.id) {
                        this.currentSearch = s;
                        this.idSearch = '' + this.currentSearch.id;
                        this.location.replaceState('/app/search/' + this.currentSearch.id);
                        this.url = '/app/search/' + this.currentSearch.id;
                    }
                });
            } else {
                this.trackingService.click('search_result_search_duplicate_cancel', this.currentSearch.id);
            }
        });
    }

    deleteSearch() {
        const dialogRef = this.dialog.open(ConfirmComponent, {
            width: '420px',
            data: {message: 'Êtes-vous sûr de vouloir supprimer la recherche "' + this.currentSearch.title + '"'},
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result === true) {
                this.trackingService.click('search_result_search_delete_confirm', this.currentSearch.id);
                this.adService.deleteSearch(this.currentSearch).subscribe(r => {
                    this.userSearchs.forEach((s, i) => {
                        if (s.id === this.currentSearch.id) {
                            this.userSearchs.splice(i, 1);
                        }
                    });
                    this.router.navigate(['/app/search/result']);
                    this.alertService.success('Recherche supprimée.', true);
                }, error => {
                    this.alertService.error('une erreur est survenue, veuillez réessayer ou nous contacter si le problème persiste.');
                });
            } else {
                this.trackingService.click('search_result_search_delete_cancel', this.currentSearch.id);
            }
        });
    }

    saveSearch() {
        if (!this.authenticationService.isAllowed('essentiel')) {
            this.upgradePlan('assets/upgrade/search.png', 'Moteur de recherche', 'Essentiel');
        } else if (this.authenticationService.isPartner && this.userSearchs.length >= PARTNER_MAX_SEARCH) {
            this.showDemoAccount();
        } else {
            const dialogRef = this.dialog.open(SaveComponent, {
                width: '420px',
                position: {top: (this.deviceService.isMobile() ? '55px' : '')},
                data: {searchParams: this.currentSearch.search_ad_params, userSearch: this.currentSearch},
            });

            dialogRef.afterClosed().subscribe(result => {
                if (result !== false && result !== undefined) {
                    this.trackingService.click('search_result_search_save_confirm', this.currentSearch.id);
                    this.userSearchs.push(result.currentSearch);
                    this.userSearchs.forEach(s => {
                        if (s.id === result.currentSearch.id) {
                            this.currentSearch = s;
                            this.idSearch = '' + this.currentSearch.id;
                            this.location.replaceState('/app/search/' + this.currentSearch.id);
                            this.url = '/app/search/' + this.currentSearch.id;
                            this.dialog.open(AlertConfirmComponent, {
                                width: '420px',
                                data: {mode: 'recherche'},
                            });
                        }
                    });
                } else {
                    this.trackingService.click('search_result_search_save_cancel', this.currentSearch.id);
                }
            });
        }
    }

    saveAlerte() {
        if (this.idSearch == 'result') {
            return;
        }
        if (!this.authenticationService.isAllowed('essentiel')) {
            this.upgradePlan('assets/upgrade/alert.png', 'Alertes E-mails', 'Essentiel');
        } else {
            let popup = false;
            if (this.currentSearch.frequency_alert == '0') {
                popup = true;
            }
            const dialogRef = this.dialog.open(AlertComponent, {
                width: '520px',
                data: {userSearch: this.currentSearch},
            });
            dialogRef.afterClosed().subscribe(result => {
                if (result !== false && result !== undefined) {
                    this.alertService.success('Enregistrement réussi.');
                    this.trackingService.click('search_result_search_alert_confirm', this.currentSearch.id);
                    if (popup == true && result.currentSearch.frequency_alert != '0') {
                        this.dialog.open(AlertConfirmComponent, {
                            width: '420px',
                            data: {mode: 'alerte'},
                        });
                    }
                } else {
                    this.trackingService.click('search_result_search_alert_cancel', this.currentSearch.id);
                }
            });
        }
    }

    loadSearch(event) {
        this.router.navigate(['/app/search/', this.currentSearch.id]);
        this.url = '/app/search/' + this.currentSearch.id;
    }

    // returnUrl vers la carte d'une annonce : conserve la page courante pour que le
    // retour re-affiche la bonne page et que le scroll vers l'ancre trouve la carte
    adReturnUrl(aiId): string {
        return this.url + (this.page > 1 ? '?page=' + this.page : '') + '#ad_' + aiId;
    }

    getSortLabel(): string {
        const opt = this.sortOptions.find(o => o.value === this.sort);
        return opt ? opt.label : '';
    }

    /**
     * Barre de filtres rapides (chips desktop) : édite directement search_ad_params,
     * persiste (recherche enregistrée -> API, sinon recherche courante) puis relance la recherche.
     */
    get quickParams() {
        return this.currentSearch ? this.currentSearch.search_ad_params : null;
    }

    /**
     * Brouillon des popups de filtres : la popup édite directement search_ad_params,
     * mais rien n'est envoyé tant que « Appliquer » n'est pas cliqué. Une fermeture
     * sans application restaure l'état d'avant l'ouverture (l'instantané pris à
     * l'ouverture), sinon le chip afficherait un filtre jamais appliqué.
     */
    private quickDraft: string = null;

    onFilterMenuOpened(trigger: MatMenuTrigger) {
        super.onFilterMenuOpened(trigger);
        this.quickDraft = this.quickParams ? JSON.stringify(this.quickParams) : null;
    }

    onFilterMenuClosed() {
        if (this.quickDraft !== null && this.currentSearch) {
            this.currentSearch.search_ad_params = JSON.parse(this.quickDraft);
            this.quickDraft = null;
            this.refreshFilterStats();
        }
    }

    /** « Appliquer » : valide le brouillon, ferme la popup et relance la recherche */
    applyQuickFilter(trigger: MatMenuTrigger) {
        this.quickDraft = null; // le brouillon devient l'état courant : pas de restauration
        trigger.closeMenu();
        this.applyQuickFilters();
    }

    /** « Effacer » : vide le filtre de la popup ouverte, sans fermer ni lancer de requête */
    clearQuickFilter(key: string) {
        const p = this.quickParams;
        if (!p) {
            return;
        }
        if (key === 'cities') {
            // La zone de recherche couvre les villes ET le secteur enregistré : « Effacer » vide les deux
            p.cities = [];
            p.search_city_params_id = 0;
        } else if (key === 'estate_type') {
            p.estate_type = [];
        } else if (key === 'dpe') {
            // Vider, pas remettre A..G cochés : « Effacer » doit décocher ce qui est affiché
            p.dpe = [];
        } else {
            p[key] = [];
        }
        this.filterChanged$.next();
    }

    applyQuickFilters() {
        this.trackingService.click('search_result_filter_bar', this.currentSearch.id ? this.currentSearch.id : 'result');
        if (this.idSearch != 'result' && this.currentSearch.id) {
            this.adService.editUserSearch(this.currentSearch).subscribe(() => this.search(1));
        } else {
            this.userService.setCurrentSearch(this.currentSearch);
            this.search(1);
        }
    }

    // filtersDrawer / saveFloating* / scroll : hérités de ResultsFloatingBase

    openFiltersDrawer() {
        this.trackingService.click('search_result_filter', this.currentSearch && this.currentSearch.id ? this.currentSearch.id : 'result');
        this.closeAllFilterMenus();
        this.filtersDrawer = true;
    }

    onDrawerParams(params) {
        // Le tri reste piloté par la page résultats (getSearchParams() du bandeau ne le connaît pas)
        params.sort = this.currentSearch.search_ad_params.sort;
        params.sort_order = this.currentSearch.search_ad_params.sort_order;
        this.currentSearch.search_ad_params = params;
        this.applyQuickFilters();
    }

    // --- Ville (autocomplete, mêmes interactions que la barre des favoris) ---
    // Rayon autour d'une ville : mêmes valeurs que la page filtres, en slider
    distanceValues = [0, 3, 5, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100];
    kmSliderOptions: Options = {
        stepsArray: this.distanceValues.map(v => ({value: v})),
        hideLimitLabels: true,
        hidePointerLabels: true,
        showSelectionBar: true,
    };

    setVilleKm(city: City, km: number) {
        city.km = km;
        this.filterChanged$.next();
    }

    // Règle projet : debounce ~400ms avant l'API, jamais un appel par frappe
    private villeSearch$ = new Subject<string>();

    searchVilles(text: string) {
        this.villeSearchText = text;
        this.villeSearch$.next(text);
    }

    selectVille(city: City) {
        const p = this.quickParams;
        if (!p.cities) {
            p.cities = [];
        }
        if (!p.cities.find(c => c.city_code === city.city_code)) {
            city.km = 0;
            p.cities.push(city);
            this.filterChanged$.next();
        }
        this.villeSearchText = '';
        // Vider via le flux — réassigner villeResults$ débrancherait définitivement
        // le pipeline debounce construit dans ngOnInit (plus aucune suggestion ensuite)
        this.villeSearch$.next('');
    }

    removeVille(city: City) {
        const p = this.quickParams;
        p.cities = (p.cities || []).filter(c => c.city_code !== city.city_code);
        this.filterChanged$.next();
    }

    // --- Plages prix / rendement (bornes stockées dans des tableaux [min, max]) ---
    // Ce qui est affiché = ce qui est envoyé : seule une borne null est vide. L'API applique
    // toute valeur telle quelle (ex. rendement max 25), il n'y a plus de borne par défaut cachée.
    getRange(key: string, index: number): number {
        const v = this.quickParams && this.quickParams[key];
        if (!v || typeof v[index] !== 'number' || isNaN(v[index])) {
            return null;
        }
        // Plages libres (prix, surface...) : 0 = borne non renseignée (convention API)
        if (!ResultsComponent.RANGE_BOUNDS[key] && v[index] === 0) {
            return null;
        }
        // Minimum à 0 = pas de filtre (sauf plages signées où 0 est une vraie borne)
        if (index === 0 && v[0] === 0 && !ResultsComponent.SIGNED_RANGES.includes(key)) {
            return null;
        }
        return v[index];
    }

    setRange(key: string, index: number, value: any) {
        const p = this.quickParams;
        const range = [this.getRange(key, 0), this.getRange(key, 1)];
        range[index] = (value === '' || value === null || isNaN(+value)) ? null : +value;
        // Borne manquante = null : l'API l'ignore, alors qu'une valeur (même l'ancienne borne
        // par défaut, ex. 25 % de rendement) s'appliquerait telle quelle
        p[key] = (range[0] === null && range[1] === null) ? [] : range;
        this.filterChanged$.next();
    }

    getRangeLabel(key: string, suffix: string): string {
        const min = this.getRange(key, 0);
        const max = this.getRange(key, 1);
        const f = v => key === 'price' ? this.commonService.formatPrice(v) : v + suffix;
        if (min !== null && max !== null) {
            return f(min) + '-' + f(max);
        }
        if (min !== null) {
            return '>' + f(min);
        }
        if (max !== null) {
            return '<' + f(max);
        }
        return '';
    }

    isRangeSet(key: string): boolean {
        return this.getRange(key, 0) !== null || this.getRange(key, 1) !== null;
    }

    // --- Type de bien (mêmes règles que toogleType de la page filtres) ---
    toggleEstateType(value: string) {
        if (value == 'commerce-fonddecommerce' && !this.authenticationService.isAllowed('expert')) {
            this.upgradePlan('assets/upgrade/search.png', 'Moteur de recherche', 'Expert');
            return;
        }
        const p = this.quickParams;
        let types = p.estate_type || [];
        if (types.includes(value)) {
            types = types.filter(t => t !== value);
            if (value == 'commerce-fonddecommerce') {
                types = types.filter(t => t !== 'commerce' && t !== 'fondsdecommerce');
            }
        } else {
            types = types.concat([value]);
            if (value == 'commerce-fonddecommerce') {
                ['commerce', 'fondsdecommerce'].forEach(t => {
                    if (!types.includes(t)) {
                        types = types.concat([t]);
                    }
                });
            }
        }
        p.estate_type = types;
        this.filterChanged$.next();
    }

    isEstateTypeSelected(value: string): boolean {
        return !!(this.quickParams && (this.quickParams.estate_type || []).includes(value));
    }

    getEstateTypeLabel(): string {
        if (!this.quickParams) {
            return '';
        }
        // Pas de troncature ici : le chip a une largeur fixe et coupe en « … » (CSS).
        return this.estateTypeOptions.filter(o => this.isEstateTypeSelected(o.value)).map(o => o.label).join(', ');
    }

    // DPE (chip rapide) : mêmes valeurs que la page filtres (0 = sans DPE, 1..7 = A..G)
    private static readonly DPE_LABELS = ['NC', 'A', 'B', 'C', 'D', 'E', 'F', 'G'];

    isDpeSelected(value: number): boolean {
        return !!(this.quickParams && (this.quickParams.dpe || []).includes(value));
    }

    // Filtre DPE actif = différent du défaut (tout coché, NC inclus).
    // Champ absent/vide (anciennes recherches sauvegardées) = pas de filtre.
    private computeDpeFiltered(): boolean {
        const dpe = this.quickParams && this.quickParams.dpe || [];
        if (!dpe.length) {
            return false;
        }
        return JSON.stringify([...dpe].sort()) !== JSON.stringify([...SEARCH_PARAMS.dpe].sort());
    }

    toggleDpe(value: number) {
        const p = this.quickParams;
        const dpe = p.dpe || [];
        p.dpe = dpe.includes(value) ? dpe.filter(v => v !== value) : dpe.concat([value]);
        this.filterChanged$.next();
    }

    getDpeLabel(): string {
        const dpe = this.quickParams && this.quickParams.dpe || [];
        if ([1, 2, 3, 4, 5, 6, 7].every(v => dpe.includes(v))) {
            return 'Tous';
        }
        return dpe.slice().sort((a, b) => a - b)
            .map(v => ResultsComponent.DPE_LABELS[v]).join(', ');
    }

    getVilleLabel(): string {
        const cities = this.quickParams && this.quickParams.cities || [];
        // Un secteur enregistré prime : c'est lui qui définit la zone
        const secteur = this.getSecteur();
        if (secteur) {
            return secteur.title;
        }
        if (cities.length === 0) {
            return '';
        }
        if (cities.length === 1) {
            return cities[0].name;
        }
        return cities.length + ' sélectionnée(s)';
    }

    // Zone de recherche active : au moins une ville, ou un secteur enregistré
    isZoneActive(): boolean {
        const p = this.quickParams;
        return !!p && ((p.cities || []).length > 0 || (p.search_city_params_id || 0) > 0);
    }

    // Secteur enregistré actuellement sélectionné, null si aucun
    getSecteur(): UserSearchCity {
        const id = this.quickParams && this.quickParams.search_city_params_id;
        if (!id) {
            return null;
        }
        return this.userSearchsCity.find(s => '' + s.id === '' + id) || null;
    }

    // L'id du secteur retenu dans les paramètres est tantôt un nombre, tantôt une chaîne
    // selon sa provenance : sans ça le select ne retrouve pas l'option déjà sélectionnée.
    compareSecteur = (a: any, b: any): boolean => '' + (a || 0) === '' + (b || 0);

    // Choix dans le select des secteurs enregistrés (0 = aucun)
    selectSecteur(id: any) {
        const p = this.quickParams;
        if (!p) {
            return;
        }
        p.search_city_params_id = parseInt(id, 10) || 0;
        this.filterChanged$.next();
    }

    // Fermeture des menus de la barre (clic extérieur, ouverture d'un autre menu) :
    // héritée de FilterMenusBase, seule la liste des triggers est propre à la page
    protected filterMenuTriggers(): MatMenuTrigger[] {
        return [this.villeTrigger, this.priceTrigger, this.surfaceTrigger, this.rendementTrigger,
            this.typeTrigger, this.cashflowTrigger, this.dpeTrigger];
    }

    // Bornes des filtres à plage (mêmes valeurs que les sliders des filtres) :
    // une plage qui couvre toute la borne = valeur par défaut, donc filtre inactif
    // Plages à bornes signées / décimales (par opposition aux plages libres où 0 = absent).
    // Les valeurs ne sont plus des bornes par défaut : l'API n'a plus de sentinelle.
    // Plages où un minimum de 0 est une vraie borne (valeurs négatives possibles)
    private static readonly SIGNED_RANGES = ['cashflow', 'squarePriceDiff'];

    private static readonly RANGE_BOUNDS = {
        squarePrice: [0, 20000],
        squarePriceDiff: [-100, 100],
        rendement: [0, 25],
        cashflow: [-1000, 2000],
        price_change_percent: [0, 100],
        price_change_euro: [0, 100000],
        amount_copro: [0, 10000],
        month: [0, 24],
    };

    private rangeActive(key: string, value: any): boolean {
        if (!value || !value.length) {
            return false;
        }
        const num = x => typeof x === 'number' && !isNaN(x);
        const bounds = ResultsComponent.RANGE_BOUNDS[key];
        if (bounds) {
            const minActive = num(value[0]) && (value[0] !== 0 || ResultsComponent.SIGNED_RANGES.includes(key));
            return minActive || num(value[1]);
        }
        // Plages libres (prix, surfaces, nb lots) : actives dès qu'une borne est renseignée
        return (num(value[0]) && value[0] > 0) || (num(value[1]) && value[1] > 0);
    }

    // Compteur de filtres actifs et état du chip DPE, mis en cache : les recalculer
    // à chaque cycle de change detection (scroll, survol...) coûterait cher en
    // JSON.stringify. Rafraîchis à chaque changement de filtre et de recherche courante.
    activeFilterCount = 0;
    dpeFiltered = false;

    refreshFilterStats() {
        this.activeFilterCount = this.computeActiveFilterCount();
        this.dpeFiltered = this.computeDpeFiltered();
    }

    // Nombre de filtres actifs = qui diffèrent des valeurs par défaut.
    // Champ absent/vide (anciennes recherches sauvegardées) = filtre inactif.
    private computeActiveFilterCount(): number {
        if (!this.currentSearch || !this.currentSearch.search_ad_params) {
            return 0;
        }
        const p = this.currentSearch.search_ad_params;
        let count = 0;
        const diff = key => {
            const val = p[key];
            if (!val || !val.length) {
                return false;
            }
            return JSON.stringify([...val].sort()) !== JSON.stringify([...(SEARCH_PARAMS[key] || [])].sort());
        };

        if (p.search) { count++; }
        if (p.search_title) { count++; }
        if ((p.cities || []).length || (p.region || []).length || (p.departement || []).length
            || (p.search_city_params_id || 0) != 0) { count++; }
        ['estate_type', 'category', 'estate_sale', 'owner_type', 'rooms', 'floor', 'work', 'rent', 'dpe', 'assets', 'other']
            .forEach(k => { if (diff(k)) { count++; } });
        if (p.maison_divisible === true) { count++; } // défaut : false
        if (p.opened === true) { count++; }
        if (p.exclude_hidden === true) { count++; }
        ['price', 'surface', 'surface_land', 'squarePrice', 'squarePriceDiff', 'month', 'rendement', 'cashflow',
            'price_change_percent', 'price_change_euro', 'amount_copro', 'nb_lots']
            .forEach(k => { if (this.rangeActive(k, p[k])) { count++; } });
        return count;
    }

    // Nouvelle recherche : vide les filtres puis ouvre le bandeau de filtres
    // (desktop) ou la page filtres (mobile, pas de bandeau sous 768px)
    newSearch() {
        const search = ({} as UserSearch);
        search.search_ad_params = JSON.parse(JSON.stringify(SEARCH_PARAMS));
        this.userService.setCurrentSearch(search);
        if (window.innerWidth < 768) {
            this.router.navigate(['/app/search/result/filters']);
            return;
        }
        if (this.idSearch == 'result') {
            this.currentSearch = search;
            this.search(1);
        } else {
            this.router.navigate(['/app/search/result']);
        }
        this.openFiltersDrawer();
    }

    get filteredUserSearchs(): UserSearch[] {
        return this.searchListText
            ? this.userSearchs.filter(s => s.title.toLowerCase().includes(this.searchListText.toLowerCase()))
            : this.userSearchs;
    }

    displayColumsSelection() {
        this.columsSelection = !this.columsSelection;
    }

    onColChange(val) {
        if (!this.authenticationService.isAllowed('expert')) {
            this.upgradePlan('assets/upgrade/indicateurs.png', 'Personnalisation des favoris', 'Expert');
        } else {
            this.trackingService.click('search_result_indicateur_change', this.currentSearch.id ? this.currentSearch.id : 'result');
            if (_.difference(val, this.displayedColumns).length !== 0) {
                // Checked
                this.displayedColumns.push(_.difference(val, this.displayedColumns)[0]);
            } else if (_.difference(this.displayedColumns, val).length !== 0) {
                // Unchecked
                this.displayedColumns = _.without(this.displayedColumns, _.difference(this.displayedColumns, val)[0]);
            }
            this.authenticationService.currentUser.user_dashboard.search_kpi = this.displayedColumns;
            this.userService.updateDashboard(this.authenticationService.currentUser);
        }
    }

    previewAd(favorite, index) {
        if (favorite.mask) {
            return;
        }
        const dialogRef = this.dialog.open(PreviewPopupComponent, {
            width: '1060px',
            height: '610px',
            // returnUrl avec l'ancre de la carte : le retour depuis l'annonce re-scrolle jusqu'à elle
            data: {favorite: favorite, url: this.adReturnUrl(favorite.ad.ai_id)},
        });
        dialogRef.afterClosed().subscribe(result => {
            if (result == true) {
                this.trackingService.click('search_result_preview_add_fav', favorite.ad.ai_id);
            } else {
                this.trackingService.click('search_result_preview_close', favorite.ad.ai_id);
            }
        });
    }

    noteFavorite(favorite): void {
        const dialogRef = this.dialog.open(NotesComponent, {
            width: '420px',
            position: {top: (this.deviceService.isMobile() ? '55px' : '')},
            data: {favorite: favorite},
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result !== false && result !== undefined) {
                favorite.comment = result.comment;
            }
        });
    }

    isNew(favorite) {
        let startDate = new Date(favorite.ad.fpb).getTime();
        if (new Date().getTime() - startDate < 86400000) {
            return true;
        }
        return false;
    }

    openTuto() {
        const dialogRef = this.dialog.open(TutoComponent, {
            width: '1000px',
            data: {video: 'search'}
        });
    }

    protected readonly EVOL_DEMO_LAST_YEAR = EVOL_DEMO_LAST_YEAR;
}
